<div *ngIf="activeQuestion" class="empathy-settings__container">
  <div class="empathy-settings__title">
    <span class="fs__xl fw__500">Settings</span>
  </div>
  <div class="empathy-settings__content">
    @if (questionTypeSettingsComponent[activeQuestion.value.type]; as settings) {
      <ng-container *ngComponentOutlet="settings"></ng-container>
    } @else {
      <p class="empathy-settings__no-configured fs__md fw__600">This question type has not extra settings to configure</p>
    }
  </div>
</div>
